import React from 'react';
import * as PhosphorIcons from '@phosphor-icons/react';
import { getPhosphorIcon, getPhosphorWeight, getAdditionalClasses } from '../../config/phosphor-icon-mapping';

interface IIconProps {
	iconClass: string;
	faModifier?: string;
	size?: number | string;
}

export const Icon = (props: IIconProps) => {
	// First try to map from the legacy Font Awesome name
	let phosphorIconName = getPhosphorIcon(props.iconClass);

	// If no mapping found, check if iconClass is already a valid Phosphor icon name
	if (!phosphorIconName && props.iconClass in PhosphorIcons) {
		phosphorIconName = props.iconClass as keyof typeof PhosphorIcons;
	}

	if (!phosphorIconName) {
		console.warn('Unknown icon, no Phosphor mapping found:', props.iconClass);
		phosphorIconName = 'Question';
	}

	const IconComponent = PhosphorIcons[phosphorIconName] as React.ComponentType<PhosphorIcons.IconProps>;

	const weight = getPhosphorWeight(props.faModifier);
	const additionalClasses = getAdditionalClasses(props.faModifier);
	const size = props.size || 15;

	// Handle fa-pulse animation
	const isPulse = props.faModifier?.includes('fa-pulse');
	const className = `phosphor-icon ${additionalClasses} ${isPulse ? 'icon-pulse' : ''}`.trim();

	return (
		<span className="icon-container">
			<IconComponent size={size} weight={weight} className={className} data-iconname={phosphorIconName} />
		</span>
	);
};
